import React from "react";
import NoSubscription from "../components/RestrictedComponents/NoSubscription";

export const NoSubscriptionPage = () => {
    return (
        <div>
            <NoSubscription />
        </div>
    )
}